  <div *ngIf="isUat">
    <span>UAT</span>
  </div>